
document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const menu = document.querySelector('[data-hoh-mobile-menu]');
  const scrim = document.querySelector('[data-hoh-scrim]');
  const menuOpen = document.querySelector('[data-hoh-menu-open]');
  const menuClose = document.querySelector('[data-hoh-menu-close]');
  const searchPanel = document.querySelector('[data-hoh-search-panel]');
  const searchOpen = document.querySelector('[data-hoh-search-open]');
  const searchClose = document.querySelector('[data-hoh-search-close]');

  const lock = () => body.classList.add('locked');
  const unlock = () => body.classList.remove('locked');
  const closeMenu = () => {
    if (!menu) return;
    menu.classList.remove('open'); menu.setAttribute('aria-hidden','true');
    if (scrim) scrim.classList.remove('open'); unlock();
  };
  const openMenu = () => {
    if (!menu) return;
    menu.classList.add('open'); menu.setAttribute('aria-hidden','false');
    if (scrim) scrim.classList.add('open'); lock();
  };
  menuOpen?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  scrim?.addEventListener('click', closeMenu);
  menu?.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));

  searchOpen?.addEventListener('click', () => {
    if (!searchPanel) return;
    searchPanel.classList.toggle('open');
    searchPanel.setAttribute('aria-hidden', searchPanel.classList.contains('open') ? 'false' : 'true');
    if (searchPanel.classList.contains('open')) setTimeout(() => searchPanel.querySelector('input')?.focus(), 50);
  });
  searchClose?.addEventListener('click', () => {
    searchPanel?.classList.remove('open'); searchPanel?.setAttribute('aria-hidden','true');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeMenu(); searchPanel?.classList.remove('open'); }
  });

 // Product media gallery
const productMain = document.querySelector('[data-hoh-product-main]');
const productThumbs = document.querySelectorAll('[data-hoh-product-thumb]');

productThumbs.forEach((btn) => {
  btn.addEventListener('click', () => {
    if (!productMain) return;

    const url = btn.dataset.image;
    const alt = btn.dataset.alt || '';
    const image = productMain.querySelector('img');

    if (image && url) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = url;
      image.alt = alt;
    }

    productThumbs.forEach((thumb) => {
      thumb.classList.remove('is-active');
    });

    btn.classList.add('is-active');
  });
});

  // Variant price display
  document.querySelectorAll('[data-hoh-variant-select]').forEach(select => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const variantImage = option.dataset.image;

if (variantImage && productMain) {
  const mainImage = productMain.querySelector('img');

  if (mainImage) {
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = variantImage;

    // Highlight corresponding thumbnail
    productThumbs.forEach((thumb) => {
      thumb.classList.toggle(
        'is-active',
        thumb.dataset.image === variantImage
      );
    });
  }
}
      const scope = select.closest('[data-hoh-product-form-scope]');
      const price = scope?.querySelector('[data-hoh-current-price]');
      const compare = scope?.querySelector('[data-hoh-compare-price]');
      const add = scope?.querySelector('[data-hoh-add-button]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (add) {
        const available = option.dataset.available === 'true';
        add.disabled = !available;
        add.textContent = available ? 'Add to bag' : 'Sold out';
      }
    });
  });
});
